import { render, staticRenderFns } from "./AlignTabsWithToolbarTitle.vue?vue&type=template&id=f427491a&"
import script from "./AlignTabsWithToolbarTitle.vue?vue&type=script&lang=js&"
export * from "./AlignTabsWithToolbarTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports